module.exports = __webpack_public_path__ + "img/Copyright_pic06.7c1631f7.jpg";